import { useEffect } from 'react';

/**
 * Keeps a paged list's page within the list. Where rows leave it (names gathered into an allergen, a filter, someone
 * else's change) and it now ends before the page shown, the page moves to the last one rather than showing an empty
 * page whose pager is hidden, because a list of one page has none.
 *
 * @param page The page shown.
 * @param setPage Moves it.
 * @param totalPages The list's page count as last read; nothing moves until it is known.
 */
export function useClampedPage(page: number, setPage: (page: number) => void, totalPages: number | undefined) {
  useEffect(() => {
    if (totalPages === undefined) return;
    const last = Math.max(1, totalPages);
    if (page > last) setPage(last);
  }, [page, setPage, totalPages]);
}
